<!-- =========================================================================================
    File Name: ForgotPassword.vue
    Description: FOrgot Password Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
    <div class="h-screen flex w-full bg-img">
        <div class="vx-col w-4/5 sm:w-4/5 md:w-3/5 lg:w-3/4 xl:w-3/5 mx-auto self-center">
            <vx-card>
                <div slot="no-body" class="full-page-bg-color">
                    <div class="vx-row">
                        <div class="vx-col hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                            <img src="@/assets/images/pages/forgot-password.png" alt="login" class="mx-auto">
                        </div>
                        <div class="vx-col sm:w-full md:w-full lg:w-1/2 mx-auto self-center d-theme-dark-bg">
                            <div class="p-8">
                                <div class="vx-card__title mb-6">
                                    <h4 class="mb-4">Recover your password</h4>
                                    <p>Please enter your email address or your username and we'll send you instructions on how to reset your password.</p>
                                </div>
                                <!-- <vs-alert color="success" icon-pack="feather" icon="icon-check-circle">
                                <span>test</span>
                                </vs-alert> -->

                                <vs-input 
                                    type="text"
                                    v-validate="'required|min:3'"
                                    label-placeholder="Email/Username" 
                                    v-model="value" 
                                    class="w-full mb-8" />
                                <span class="text-danger text-sm">{{ errors.first('value') }}</span>

                                <vs-button type="border" to="/login" class="px-4 w-full md:w-auto">Back To Login</vs-button>
                                <vs-button id="submitBtn" class="float-right px-4 w-full md:w-auto mt-3 mb-8 md:mt-0 md:mb-0 vs-con-loading__container" @click="recoverPassword" :disabled="!validateForm">Recover Password</vs-button>
                            </div>
                        </div>
                    </div>
                </div>
            </vx-card>
        </div>
    </div>
</template>

<script>
import API from "@/API.js"
const axios = require('axios')

export default {
  data () {
    return {
      notify: 'Server Error',

      value: ''
    }
  },

  computed: {
    validateForm () {
      return !this.errors.any() && this.value !== ''
    }
  },

  methods: {
    reset() {
      this.value = ''
    },

    recoverPassword () {
      this.$vs.loading({
        background: 'primary',
        color: '#fff',
        container: "#submitBtn",
        scale: 0.45
      })

      axios.post(API.endpoint + '/forgot_password', {
        keyword: this.value
      }).then(res => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")
        this.notify = res.data.message.split('_').join(' ')

        this.$router.push({ path: '/login'})
        this.reset()

        this.$vs.notify({
          title: 'Thank You',
          text: this.notify,
          color: 'success',
          position: 'top-right'
        })

      }).catch(error => {
        this.$vs.loading.close("#submitBtn > .con-vs-loading")

        if(error.response.status === 400){
          this.notify = 'Server Error'
          if(typeof error.response.data.message !== undefined) {
            this.notify = error.response.data.message.split('_').join(' ')
          }

          this.$vs.notify({
            title: 'Sorry',
            text: this.notify,
            color: 'danger',
            position: 'top-right'
          })
        }
      })
    },
  },
  created() {   
  }
}
</script>
